<template>
  <div class="tour__holder">
    <div>
      <div class="modal" :class="'planner'" data-feature="modal" data-name="appointment_plan">
        <div class="modal__content" data-feature="modal-active-area">
          <div class="panel">
            <form id="plannerFrom" :action="route" method="POST">
              <h3
                class="panel__title"
              >{{ locales.property && locales.property.plan_your_appointment}}</h3>
              <ul class="form__list">
                <li class="form__item">
                  <input type="hidden" name="property_id" :value="property">
                  <input type="hidden" name="subscription_id" :value="subscription">
                  <input type="hidden" name="website_id" :value="website">
                  <v-datepicker-visible
                    :label="locales.common && locales.common.choose_date"
                    :past-dates="false"
                    :excluded-dates="excludedDates" 
                    :excluded-days="excludedDays"
                    name="date"
                    v-model="date"
                    v-validate="`required`"
                    @input="checkAvailableTimes"
                  ></v-datepicker-visible>
                </li>
                {{ times.length }}
                <li class="form__item" v-show="show" name="time">
                  <v-radios-public
                    :options="times"
                    v-validate="`required`"
                    name="time"
                    v-model="time"
                    :label="locales.common && locales.common.choose_time"
                  ></v-radios-public>
                </li>
              </ul>
              <span class="print_errors error"></span>
              <div class="panel__paragraph">
                <button
                  class="tour__button js-plan-confirm"
                  type="submit"
                  @click.prevent="plan"
                >{{ locales.property && locales.property.plan_your_appointment }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button
        class="tour__button"
        data-feature="open-modal"
        data-target="appointment_plan"
      >{{locales.property && locales.property.plan_your_appointment}}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import sweetalert from "sweetalert";
export default {
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapGetters(["locales"])
  },
  data() {
    return {
      times: {},
      show: false,
      date: null,
      time: null
    };
  },
  props: {
    route: {
      default: "",
      type: String
    },
    property: {
      default: null,
      type: Number
    },
    subscription: {
      default: null,
      type: Number
    },
    website: {
      default: null,
      type: Number
    },
    agendaRoute: {
      default: "",
      type: String
    },
    excludedDays: {
      default: [],
      type: Array
    },
    excludedDates: {
      default: [],
      type: Array
    }
  },
  methods: {
    plan: function(e) {
      var that = this;
      e.preventDefault();
      this.$validator.validateAll().then(res => {
        if (res) {
          let postData = $("#plannerFrom").serializeArray();
          let action = $("#plannerFrom").attr("action");
          $(".js-plan-confirm").attr("disabled", true);
          $.ajax({
            url: action,
            type: "POST",
            data: postData,
            cache: false,
            success: function(data) {
              that.show = false;
              $(".modal").hide();
              let page = document.getElementById("page");
              page.classList.remove("z-index");
              $(".js-plan-confirm").removeAttr("disabled");
              $('[data-target="appointment_plan"]').parents('.tour').hide();

              sweetalert(window.app.locales.common.success, window.app.locales.appointments.plan_added, 'success').then(value => {
                  that.times = {};
                  that.date = null;
                  that.time = null;
                  that.$validator.reset()
              });
            },
            error: function(e) {
              $(".modal").hide();
              that.show = false;
              let page = document.getElementById("page");
              page.classList.remove("z-index");
              $(".js-plan-confirm").removeAttr("disabled");
              if(e.status == 403){
                sweetalert(window.app.locales.common.error, window.app.locales.common.login_required, 'error').then(()=>{ window.location.reload() });
              }else{
                sweetalert(window.app.locales.common.error, window.app.locales.appointments.planner_error, "error").then(value => {
                    that.times = {};
                    that.date = null;
                    that.time = null;
                    that.$validator.reset()
                });                
              }
            }
          });
        } else {
          var msg = [];
          for (var item of this.$validator.errors.items) {
            if ((item.field == "time" && this.show) || item.field != "time") {
              msg.push(item.msg);
            }
          }
          $(".print_errors").html(msg.join("<br>"));
        }
      });
    },
    checkAvailableTimes() {
      if (this.date && this.date != "") {
        window.axios
          .post(this.agendaRoute, {
            date: this.date,
            propertyId: this.property
          })
          .then(response => {
            if (response.data !== undefined && response.data != "") {
              this.times = response.data;
              this.show = true;
            } else {
              this.times = {};
              this.show = false;
            }
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/AppointmentPlanner.vue